var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 3,
    viewBox: "0 0 11 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.862 0.32C2.13267 0.32 2.352 0.404 2.52 0.572C2.688 0.74 2.772 0.959333 2.772 1.23C2.772 1.50067 2.688 1.72 2.52 1.888C2.352 2.056 2.13267 2.14 1.862 2.14C1.59133 2.14 1.372 2.056 1.204 1.888C1.036 1.72 0.952 1.50067 0.952 1.23C0.952 0.959333 1.036 0.74 1.204 0.572C1.372 0.404 1.59133 0.32 1.862 0.32ZM5.58075 0.32C5.85142 0.32 6.07075 0.404 6.23875 0.572C6.40675 0.74 6.49075 0.959333 6.49075 1.23C6.49075 1.50067 6.40675 1.72 6.23875 1.888C6.07075 2.056 5.85142 2.14 5.58075 2.14C5.31008 2.14 5.09075 2.056 4.92275 1.888C4.75475 1.72 4.67075 1.50067 4.67075 1.23C4.67075 0.959333 4.75475 0.74 4.92275 0.572C5.09075 0.404 5.31008 0.32 5.58075 0.32ZM9.2995 0.32C9.57017 0.32 9.7895 0.404 9.9575 0.572C10.1255 0.74 10.2095 0.959333 10.2095 1.23C10.2095 1.50067 10.1255 1.72 9.9575 1.888C9.7895 2.056 9.57017 2.14 9.2995 2.14C9.02883 2.14 8.8095 2.056 8.6415 1.888C8.4735 1.72 8.3895 1.50067 8.3895 1.23C8.3895 0.959333 8.4735 0.74 8.6415 0.572C8.8095 0.404 9.02883 0.32 9.2995 0.32Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.337c4d28ea5227cf41a6b0618cd63f82.svg";
export { ForwardRef as ReactComponent };